module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "part01chapter01"
    }
  }), _vm._v("One")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/dragon1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("M")]), _vm._v("iranda didn’t hear the sound he made when his face hit the sidewalk. The firecrackers were too loud, punctuating the blaring Sousa band up Stockton. Red string snapped and danced from a corner of a chop suey house on Grant, puffs of gray smoke drifting over the crowd. No cry for help, no whimper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Chinese New Year and the Rice Bowl Party, one big carnival, the City that Knows How to Have a Good Time choking Grant and Sacramento. Bush Street blocked, along with her way home to the apartment. Everybody not in an iron lung was drifting to Chinatown, some for the charity, most for the sideshow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Help the Chinese fight Japan—put a dollar in the Rice Bowl, feed starving, war-torn China. Buy me a drink, sister, it’s Chinese New Year. Don’t remember who they’re fighting, sister, they all look alike to me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Somewhere above her a window opened, and a scratchy recording of “I Can’t Give You Anything but Love” fought its way out. Miranda knelt down next to the boy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You OK, kid?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She guessed eighteen or nineteen, from the cheap but flashy clothes and the way his body had fallen, trying to protect itself. No response. She dropped her cigarette, and with effort turned him over, the feet around her finally making some room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("She bent closer. Couldn’t hear a goddamn thing except Billie Holiday.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Kid—kid, can you hear me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Nose was broken. So was his jaw. Missing teeth, both eyes black. What looked like burn marks on his cheek.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She loosened and unknotted the flimsy green tie around his neck. Eyelids fluttering, color gone, face empty of everything except memory. Unbuttoned the shiny brown jacket, saw the hole in his chest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Miranda shouted over the music: “We need a doctor! Anybody a doctor? Anybody?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The feet around her moved back a little, ripple of noise running through the crowd, music bright, singing about love. Always about love.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Couldn’t risk looking up. His eyes were open now, brown clutching hers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Love and happiness. Fucking happiness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She took a deep breath and yelled, voice straining.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Doctor! Get a goddamn doctor!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The cement was still damp with slop from the restaurants and tenements, and his fingers clawed it, looking for an answer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The crowd shivered again, surged forward. His eyes asked the question and hers lied back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Who did this? Can you understand me? Who—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He turned his head toward the direction he’d been thrown from. Last effort.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Then the bubble. Then the gurgle. Then the cop.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Move, you bastards. Move!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("His boots stood next to her, staring dumbly at the boy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“He drunk?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The voice faded, happiness run out. The record made a clacking sound, and the needle hit the label over and over. "), _c('em', [_vm._v("Clack. Clack clack.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She stood up, tired.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“He’s dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The record started up again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("I can’t give you anything but love, baby . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The cop at the Hall of Justice was the hard type, but that was the new style for 1940. One too many George Raft and Jimmy Cagney movies, and they all "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("wore their hair short and their mouths even shorter. No wink and a smile with this one. Burn at the stake, every time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Miranda inhaled deeply on the Chesterfield and crossed her legs. It distracted him for a few seconds. She watched and counted the clock ticks as he picked up her lighter, her compact, her "), _c('em', [_vm._v("Chadwick’s Street Guide")]), _vm._v(", her hat, her comb, her lipstick, her keys, her address book, her cigarette case, her notepad, her pocketbook, and a few gum wrappers and matchbooks, and looked at them as though they might be hiding a .38.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“So you say you don’t know this—Eddie Takahashi?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I said so.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He sat back in the chair. “Just because you got a license that makes it all legal . . . you’re still nothing more than the girls down on Turk. I looked you up.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Her dress hitched a little higher when she leaned over his desk to rub out the cigarette in the scarred wood. His eyes fell.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Congratulations. You can read.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Sour smile, spit at the corners. Pulled his eyes back up while he rocked on his feet, the chair squeaking in rhythm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I can read all right. It’s some record. Spain with the Reds. Came back and worked for Dianne Laroche as an escort. Then hooked up with Charlie Burnett on divorce cases . . .” He paused, savoring it, looking her up and down. “He was never one for fresh bait. Then Burnett gets bumped off, they claim you figure out who, and you get a license and take over his business and land some cushy World’s Fair job on Treasure Island, guarding Sally Rand. Takes a whore to know a whore, I guess. So . . . who was the dead Jap—a client?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Miranda dropped her eyes from the clock on the wall to the shiny, stubbled face of Star number 598. She stared at him until he flinched, his chair shrieking one last time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Get on with your job or I call my attorney.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("His hands clenched around the fountain pen, red and pulpy. “Your attorney. He your new pimp?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The section gate swung open, banging against the partition. Phil stood, twirling his hat, looking at Miranda. Star number 598 flushed purple, jumped up from the desk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“If you want to take over, Lieutenant . . .” The words trailed off in a mumble while he slid out into the hall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("Phil took off his hat, lines on his face deeper than she remembered. More gray on his chin. More paunch in his belly. Goddamn it. She wasn’t up to Phil, not today. Better to deal with the Puritan.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You do something to Collins?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She reached across the desk and took another Chesterfield out of the gold case, not speaking until she snapped it shut and returned it to its pile.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Objects to me on principle.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Phil’s eyes followed her hand when she picked up the "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("YELLOW CAB")]), _vm._v(" matchbook. After two attempts, she struck one on the desk and lit the stick, hand shaking slightly. Leaned back in the hard wooden chair and met his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Been awhile, Miranda. You look good. It’s been—how long? Since the Incubator Babies racket last year? They must be treating you right, all your Fair friends.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She shrugged. “Pays the bills. And I’m keeping busy in the off-season.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Still with divorce cases, I hear. Well, good for you. Kept Burnett in clover.” He cleared this throat, looked down at his large hands, unexpectedly helpless, folded on the desk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“So one more year . . . guess one bankrupt World’s Fair’s not enough. Maybe ’40’ll be more magic than ’39, who knows. You going back to work in May?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She took a deep drag on the Chesterfield and blew a smoke ring. Gave him half a smile.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Same troubles, same fair—shorter season. Bigger Gayway this year, though, more girl shows, more work for me. So yeah, I’m hitching my tent to Treasure Island again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He cleared his throat again, studied the floor at her feet. Pressed his hands tight on the desk, fingers splayed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’ll be retiring soon. Chief Quinn’s going home in a few days . . . the mayor’s appointing Dullea. You probably heard about it. There’ll be changes—always are. I’m not always going to be around to watch out for you. I’d like to see you get settled.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Miranda stared at the lipstick stain on her cigarette. A woman two rows over was sobbing into a handkerchief.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“If by ‘settled’ you mean married and not working, sorry, Phil. I appreciate the doting uncle routine, but I can take care of myself.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Color spread across his face, eyes dropping to her purse contents. Same "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("story, new year. Same Phil. She readjusted herself in the hard wooden chair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Let’s get on with it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Hurt eyes, sad eyes, baggy, bloodshot, old. He took a piece of paper from the drawer, dipped the fountain pen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Name?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Don’t you have all that down? I’ve been sitting with Officer League of Decency for half an—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’m the lieutenant. You’re the witness. Let’s keep it formal.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She blew another smoke ring over her shoulder, watched it sail over the head of a uniform a few desks down.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Miranda Corbie.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Hair?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Auburn. Or red. Depends on the henna.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Answer the questions. Eyes?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Brown.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He looked up. “I thought they were . . . yes. Hazel.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She tapped some ash on the cheap metal ashtray. “They’re brown to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Height?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Five feet six inches. Without heels.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Weight?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“130, stripped.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Age?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Same as last year, except a year older. Thirty-three.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Address?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“640 Mason Street, apartment number 405. No phone.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He fished around the pile on the desk and pulled out a battered card. “Monadnock Building? With the Pinkertons?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Closet on the same floor. They sometimes throw me the small fry in return for Sally Rand tickets.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Good for you. For getting your own office, and moving out of Burnett’s.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She shrugged again. “It was never much. Neither was Burnett.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He busied himself with writing. “Phone at the office is EXbrook—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“—3333. Easy for clients to remember. I was lucky.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The eyes came back to her. Like kids at a candy shop.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“They got your numbers memorized, Miri—at least their husbands do.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("She stubbed out the cigarette in the same spot on the desk and dropped it in the tray.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Like I said, I’m lucky. C’mon, Phil, let me go home. It’ll be hell getting through—they’re expecting a hundred thousand tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He leaned back, scratched his neck. “So what happened?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I was on my way home from here. Had to ID a phony check pusher, who also happens to be a bigamist.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He frowned. “You see Riordan?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Unfortunately. Tried to lick my face like a dog. I took a shortcut through Chinatown, forgetting about Rice Bowl, and got stuck on Sacramento between Grant and Waverly. About five o’clock, an hour before the street carnival, but still goddamn hard for anybody trying to get anywhere else. I saw this kid facedown on the street. Thought he was drunk, flipped him over, saw the exit wound, yelled for a doctor, and The Law shoved his way through with a nightstick. That’s it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Eddie Takahashi. Sure you don’t know him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She shook her head. “Never seen him before. Got a record?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("His voice hesitated. “Small-time. Used to be a numbers runner for Filipino Charlie, here and down in South City. Family lived on the edge of Chinatown—until ’37.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Miranda reached for her cigarette case again, opened it, grimaced, and shut it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You got a stick on you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He searched inside his coat pocket and pulled out a crumpled Old Gold package and a tarnished lighter. He lit one, his hand shaking when he took it out of his mouth and handed it to her. She inhaled, leaning back in the chair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Nanking changed a lot of things in this city, Phil. Suddenly every Japanese bayoneted babies.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He passed a hand through his short gray hair, sweat starting to bead along his scalp. Kept his voice low.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“That’s the problem. That’s why I want you to go home, and forget about this kid. Chalk him up to Nanking.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Miranda stared at the clock above his head, minute hand sweeping the time away. No use trying to make it cleaner. Not in the Hall of Justice. Not with Phil.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You mean because he got killed during the Rice Bowl Party we fucking forget about it? Just blame it on what made Nanking in the first place?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("He found a yellowed handkerchief in his pocket and wiped his forehead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Watch your mouth. You talk like a sailor, not a professor’s daughter.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Keep my father the hell out of it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Voices swirled around the room, staccato, sharp. Miranda was breathing hard, the cigarette burning between her fingers forgotten.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You’re not even going to investigate this, are you? A few feeble courtesy calls on Filipino Charlie, who’ll have an alibi, and then you’ll forget about it, stick it in a drawer, because a Japanese kid had the bad luck to get plugged in Chinatown on a day when the Chinese are raising money to fight the Rising Sun. Happy, happy fucking New Year, Phil. "), _c('em', [_vm._v("Gon Hay Fat Choy")]), _vm._v(" to you, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("His eyes glittered, and he stood up, shoving the chair into the desk with a hard clatter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Save yourself for Sally and the mashers, honey, and spare me the soap-box. The Fair will reopen in a few months, and you’ll get by. You always do. There are always men willing to make a pitch at you and fat wives willing to pay you to do it. Or do they pay you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The minute hand ticked. Somebody coughed. The clatter of typewriters started up again, the sound of bored questions and shrill answers pounding out to an eight-bar beat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Miranda calmly rubbed out the half-finished cigarette in the wood of the desk. Phil sank back into his chair, the map of broken veins in his cheeks and nose shining purple against the white.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She started to gather her things. Unhurriedly, carefully, last time. He watched her, lit a cigarette. She was putting on her hat when he said something, voice hoarse.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Don’t do it. I’m not warning you, I’m telling you. We’ve got a new chief coming in, and nobody needs the trouble right now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She made her voice sweet and mellifluous, just like Dianne had taught her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’m no trouble, sugar.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She adjusted the hat, walked around to his side of the desk, slowly, as if she were at the Club Moderne and on a job. Stood in front of him, bent forward, made sure he couldn’t help looking. Then she put a hand on his upper thigh, and rubbed it a little. His mouth hung open, desperation and horror etched on his face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You’re a good Catholic boy, Phil. Even if you’re sixty. Do us both a favor and go to confession. You don’t want to be my uncle, and we both know it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("She left him with his face in his hands, her breath ragged and trembling by the time she got to Kearny Street.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("That night she dreamed of Spain and Johnny.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The fields were golden with yellowing grain and dotted with the wings of birds, black against the cloudless sky, and they walked on dirty red roads, past one-room houses of ancient stone, and smelled the grapes in the cellar and the olives in the press. There was that moment, that one flash of truth, when she turned to him and looked in his eyes and his soul answered and everything went away and she was blind, and knew only joy, and the feeling of being whole, complete, oneself and yet more than oneself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Then the breeze from the coast brought the smell of petrol and sulfur. And the horizon was red, it was evening, and a drone, not a bee or a locust, grew louder. She tried to hold him, to hold him tight, and he fought her, overpowering her, bruising and hurting her until she had to let go, and she screamed, and she screamed, and she screamed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Miranda woke up, shaking, sweating. It was three in the morning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She flung off the cover, and swung her legs around the small bed, grabbing an almost-empty package of Chesterfields off the nightstand on her way to the window. She pushed it open, inhaling the fog that pulsed downhill on its way to Market Street and south of that to the piers, the street lamps dim with cloud-wrapped cataracts, the traffic noises muffled as if by a damp wool blanket.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("1937. At three in the morning it was always 1937.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She watched a couple in evening clothes stroll down Mason toward Union Square and the big hotels. She watched the man put his arm around the woman, watched as she leaned into him, their footsteps beating a sharp tattoo in the wet pavement. She lit a cigarette, and watched them until they were out of sight.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She smoked, and thought about Eddie Takahashi, and shivered a little. She’d be alone, but Miranda was used to that.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-399ab1ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part01chapter01.vue
// module id = 81
// module chunks = 0